export default function () {
  return {
    item: {},
    items: [],
    filterModulesItems: [],
   
    productsItems: [],
    pagination: {}
  }
}
